'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
var input = require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
var animations = require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
var screenReader = require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
require('@brandfolder/utilities');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
var standardLabel = require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
var helpText = require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');
require('../../../internal/list/standard-list/standard-list.js');
require('../../../internal/listbox/standard-listbox/standard-listbox.js');
require('../../../internal/listitem/standard-listitem/standard-listitem.js');
require('../../../internal/option/standard-option/standard-option.js');
require('../../../internal/textarea/fake-textarea.js');
require('../../../internal/textfield/textfield-addon.js');
require('../../../internal/textfield/textfield-body.js');
require('../../../internal/textfield/textfield-header.js');
require('../../../internal/textfield/textfield-icon.js');
require('../../../internal/textfield/textfield-inner.js');
var textfieldWrapper = require('../../../internal/textfield/textfield-wrapper.js');
var baseRadio = require('../base-radio/base-radio.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardRadio = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className , defaultChecked , disabled , helpText: helpText$1 , helpTextProps , id , inputProps , label , labelPosition , labelProps , look , name , onBlur , onChange , radioProps , required , requiredLabel , showLabel , textProps , value , wrapperRef , ...otherProps } = props;
    const hasHelpText = !!helpText$1;
    const hasRequired = required && !!requiredLabel;
    const helpTextId = `${id}-help-text`;
    const labelId = `${id}-label`;
    return /*#__PURE__*/ React__default.default.createElement(textfieldWrapper.TextfieldWrapper, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-radio__standard': true,
            'bf-radio__standard--disabled': disabled,
            'bf-radio__standard--help-text': hasHelpText,
            [`bf-radio__standard--label-${labelPosition}`]: showLabel,
            'bf-radio__standard--label-hidden': !showLabel,
            [`bf-radio__standard--look-${look}`]: look,
            'bf-radio__standard--required': hasRequired,
            [`${className}`]: !!className
        }),
        labelPosition: labelPosition,
        ref: wrapperRef
    }), /*#__PURE__*/ React__default.default.createElement(baseRadio.BaseRadio, _extends({}, inputProps, {
        "aria-describedby": hasHelpText ? helpTextId : undefined,
        "aria-disabled": disabled,
        className: classnames__default.default({
            'bf-radio__input': true,
            [`${inputProps?.className}`]: !!inputProps?.className
        }),
        defaultChecked: defaultChecked,
        disabled: disabled,
        id: id,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        ref: ref,
        required: hasRequired,
        value: value
    })), /*#__PURE__*/ React__default.default.createElement(standardLabel.StandardLabel, _extends({}, labelProps, {
        className: classnames__default.default({
            'bf-radio__label': true,
            [`${labelProps?.className}`]: !!labelProps?.className
        }),
        htmlFor: id,
        id: labelId,
        required: hasRequired,
        requiredLabel: requiredLabel
    }), /*#__PURE__*/ React__default.default.createElement("span", _extends({}, radioProps, {
        "aria-hidden": true,
        className: classnames__default.default({
            'bf-radio__radio': true,
            [`${radioProps?.className}`]: !!radioProps?.className
        })
    }), /*#__PURE__*/ React__default.default.createElement("svg", {
        className: "bf-radio__circle",
        viewBox: "0 0 28 28"
    }, /*#__PURE__*/ React__default.default.createElement("circle", {
        cx: "14",
        cy: "14",
        r: "7"
    }))), /*#__PURE__*/ React__default.default.createElement("span", _extends({}, textProps, {
        className: classnames__default.default({
            'bf-radio__text': true,
            [`${textProps?.className}`]: !!textProps?.className
        })
    }), label)), hasHelpText && /*#__PURE__*/ React__default.default.createElement(helpText.HelpText, _extends({}, helpTextProps, {
        id: helpTextId
    }), helpText$1));
});
const Textfield = styled__default.default(BaseStandardRadio)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;

  .bf-radio__circle {
    display: none;
  }

  .bf-radio__input {
    ${screenReader.screenReaderOnly}

    + .bf-radio__label {
      .bf-radio__radio {
        background-color: ${({ look , theme  })=>theme.radio[look].backgroundColor};
        border: 1px solid ${({ look , theme  })=>theme.radio[look].borderColor};
        border-radius: 50%;
        cursor: pointer;
        flex-shrink: 0;
        height: 14px;
        margin-block-start: 3.5px;
        outline-color: transparent;
        transition:
          background-color 0.2s ease,
          border-color 0.2s ease,
          outline-color 0.2s ease;
        width: 14px;

        &:hover {
          border-color: ${({ look , theme  })=>theme.radio[look].borderColorHover};
        }
      }
    }

    &:checked {
      + .bf-radio__label {
        .bf-radio__radio {
          animation: ${animations.bounce} 0.2s ease;
          background-color: ${({ look , theme  })=>theme.radio[look].backgroundColorChecked};
          border-color: ${({ look , theme  })=>theme.radio[look].borderColorChecked};

          .bf-radio__circle {
            display: block;

            circle {
              fill: ${({ look , theme  })=>theme.radio[look].fillColorChecked};
            }
          }
        }
      }
    }

    &:focus-visible {
      + .bf-radio__label {
        .bf-radio__radio {
          outline-color: ${({ look , theme  })=>theme.radio[look].outlineColorFocus};
          outline-offset: 2px;
          outline-style: solid;
          outline-width: 2px;
        }
      }
    }

    &:disabled {
      + .bf-radio__label {
        .bf-radio__radio {
          animation: none;
          background-color: ${({ look , theme  })=>theme.radio[look].backgroundColorDisabled};
          border-color: ${({ look , theme  })=>theme.radio[look].borderColorDisabled};
          cursor: not-allowed;

          .bf-radio__circle {
            circle {
              fill: ${({ look , theme  })=>theme.radio[look].fillColorDisabled};
            }
          }
        }
      }
    }
  }

  .bf-label__standard {
    cursor: pointer;
    font-family: ${fonts.fontFamilyBook};
    font-weight: 400;
  }

  &.bf-radio__standard--label-hidden {
    .bf-radio__input {
      + .bf-radio__label {
        .bf-radio__radio {
          position: static;
        }
      }
    }

    .bf-radio__text {
      ${screenReader.screenReaderOnly}
    }

    .bf-label__standard {
      margin-left: 0;
    }

    .bf-text__help {
      ${screenReader.screenReaderOnly}
      margin-left: 0;
    }
  }

  &.bf-textfield__wrapper--label-position-right {
    .bf-radio__text {
      margin-inline-start: 12px;
    }

    .bf-text__help {
      margin-inline-start: 26px;
    }
  }

  &.bf-textfield__wrapper--label-position-left {
    align-items: flex-end;

    .bf-radio__radio {
      order: 1;
    }

    .bf-radio__text {
      margin-inline-end: 12px;
    }

    .bf-text__help {
      margin-inline-end: 26px;
    }
  }
`;
/**
 * A `<input type="radio">` element is used to select one of a group of related options.
 * `id` and `label` are required for accessibility. Note that `name` is required to group
 * radios together properly in forms.
 *
 * `InputLabelPositions.Right` is the default label position.
 * Only `InputLabelPositions.Left` is also currently supported.
 *
 * It is recommended to use `<RadioGroup>` for most use cases, which adds styling
 * for a set of radios being grouped together.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio
 *
 * @param props StandardRadioProps
 * @returns FunctionComponent<StandardRadioProps>
 */ const StandardRadio = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { labelPosition =input.InputLabelPositions.Right , look =input.InputLooks.Default , showLabel =true , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Textfield, _extends({}, otherProps, {
        labelPosition: labelPosition,
        look: look,
        ref: ref,
        showLabel: showLabel
    })));
});

exports.StandardRadio = StandardRadio;
//# sourceMappingURL=standard-radio.js.map
